
export default {
    props: {
        tableId: {
            type: String,
            default: 'table-wrap'
        }
    },
    data() {
        return {
            tableHeight: 400
        }
    },
    methods: {
        resizeHandle() {
            if(!document.querySelector(`#${this.tableId}`)) return
            this.$nextTick(() => {
                setTimeout(() => {
                    this.tableHeight = document.querySelector(`#${this.tableId}`).offsetHeight 
                }, 500);
            })
        }
    },
    mounted() {
        this.resizeHandle()
        window.addEventListener('resize', this.resizeHandle)
        this.$once("hook:beforeDestroy", () => {
            window.removeEventListener('resize', this.resizeHandle)
        })
    }
}